import { subscriptionService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";

export const useRemoveInactiveModalViewModel = ({
  user,
  onClose,
  onRefresh,
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const deleteUserLog = async (log) =>
    stateManager.run(async () => {
      await subscriptionService.users.deleteUserAvailabilityLog({
        id: log.id,
        data: {
          modifiedOn: log.modifiedOn,
        },
        toastMessageConfig: {
          success: {
            text: `${user?.name} was successfully marked active.`,
          },
        },
      });
    });

  const deleteUserLogs = async (logs) => {
    stateManager.run(async () => {
      await Promise.all(logs.map((log) => deleteUserLog(log)));
      onClose();
      onRefresh();
    });
  };

  return { isLoading, deleteUserLogs };
};
